module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_8004.7e9fa0ee.png";